import { render } from "./Tooltip.vue?vue&type=template&id=cd44d206&bindings={\"tooltipText\":\"props\",\"position\":\"props\"}"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"
script.render = render

export default script